import React from "react";

import { Button, Modal, TextField } from "@mui/material";
import { SimpleHead } from "components";

type ReachOutPopupProps = {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (event: React.FormEvent<HTMLFormElement>) => void;
  values: {
    email_body: string;
  };
  handleChange: (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  errors: {
    email_body?: string;
  };
  handleBlur: (event: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
};

export const ReachOutPopup: React.FC<ReachOutPopupProps> = ({
  isOpen,
  onClose,
  onSubmit,
  values,
  handleChange,
  errors,
  handleBlur
}) => {
  const isEmailBodyValid = !!values.email_body.trim();

  const handleClose = () => {
    values.email_body = "";
    onClose();
  };

  return (
    <Modal
      open={isOpen}
      onClose={handleClose}
      aria-labelledby="reachout-modal-title"
      aria-describedby="reachout-modal-description"
    >
      <form className={`reachout-modal-popup ${isOpen ? "visible" : ""}`} onSubmit={onSubmit}>
        <SimpleHead onIconClick={handleClose} className="reachout-modal-popup__head">
          Add Note
        </SimpleHead>
        <div className="reachout-modal-popup__split" />
        <TextField
          sx={{
            ".MuiOutlinedInput-root": {
              p: 2
            }
          }}
          className="reachout-modal-popup__email-body"
          label="Email Body"
          value={values.email_body}
          placeholder="Enter text to be sent with the form."
          name="email_body"
          onChange={handleChange}
          multiline
          rows={3}
          maxRows={4}
          helperText={errors.email_body}
          error={!!errors.email_body}
          onBlur={handleBlur}
        />
        <div className="reachout-modal-popup__buttons">
          {/* <Button disabled={!isValid} type="submit" variant="contained"> */}
          <Button disabled={!isEmailBodyValid} type="submit" variant="contained">
            Send
          </Button>
        </div>
      </form>
    </Modal>
  );
};
